import {
  PREVENT_OPTIN_OPEN,
  TRUE_STRING
} from '../const/common';
import { log } from '../utils/debug';

const DEFAULT_HOLIDAYS_COUNTRY = 'DE';

export function checkBannerOptinShow(usedBanner, context) {
  if (usedBanner.dontShowPushOptInDuringShown) {
    sessionStorage.setItem(PREVENT_OPTIN_OPEN, TRUE_STRING);
    context.confirm.hide();
  }
}

export function isWithinDateRange(banner = {}) {
  const now = new Date();
  const startsAt = banner.startsAt ? new Date(banner.startsAt) : null;
  const endsAt = banner.endsAt ? new Date(banner.endsAt) : null;

  return (!startsAt || startsAt < now) && (!endsAt || endsAt > now);
}

export async function todayIsHoliday(banner) {
  if (!banner?.hideBannerOnHolidays) {
    return false;
  }
  try {
    const { default: Holidays } = await import('date-holidays');
    let isHoliday = false;
    const today = new Date();
    if (banner?.hideBannerOnHolidaysState?.length) {
      isHoliday = banner.hideBannerOnHolidaysState.some((state) => {
        const holiday = new Holidays(banner.hideBannerOnHolidaysCountry || DEFAULT_HOLIDAYS_COUNTRY, state.value);
        return !!holiday.isHoliday(today);
      });
    } else {
      const holiday = new Holidays(banner.hideBannerOnHolidaysCountry || DEFAULT_HOLIDAYS_COUNTRY);
      isHoliday = !!holiday.isHoliday(today);
    }
    return isHoliday;
  } catch (error) {
    log.info(error);
    return false;
  }
}

export function isCurrentTimeInTimeSlots(timetable) {
  if (!Object.keys(timetable || {}).length) {
    return true;
  }
  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  const currentTime = currentDate.getHours() * 60 + currentDate.getMinutes();

  const timeSlots = timetable[currentDay];
  if (!timeSlots) {
    return false;
  }

  return timeSlots.some((slot) => {
    const startTime = slot.startHours * 60 + slot.startMinutes;
    const endTime = slot.endHours * 60 + slot.endMinutes;
    return currentTime >= startTime && currentTime <= endTime;
  });
}
